import { trpc } from "@util/trpc/trpcClient";

function useTeam() {
  return trpc.teams.getTeam.useQuery();
}

export function useSuspenseTeam() {
  return trpc.teams.getTeam.useSuspenseQuery();
}

export default useTeam;
